import Head from 'next/head'

import type { AlternateLink } from '@/hooks/useAlternateLinks'

export const PageHead = (props: {
  disallowRobots?: boolean | null
  alternateLinks: AlternateLink[]
}) => {
  return (
    <Head>
      {props.disallowRobots === true ? <meta name="robots" content="noindex, follow" /> : null}
      {props.alternateLinks.map(({ href, hrefLang }) => (
        <link rel="alternate" href={href} hrefLang={hrefLang} key={hrefLang} />
      ))}
    </Head>
  )
}
